<div class="p-grid">
  @if (isEditable && !task.id) {
    <div class="col-12"
      style="margin-top: 11px;">
      @if (isEditable && !task.id) {
        <ng-select
          class="custom"
          required
          [items]="templateOptions"
          placeholder="Select a Task Template"
          [selectOnTab]="true"
          name="task"
          bindLabel="name"
          (change)="onTemplateSelect($event)"
          >
        </ng-select>
      }
    </div>
  }
</div>
<form class="p-grid" id="wellnessTaskForm" #wellnessTaskForm="ngForm">
  @if (canChangeStatus) {
    <div class="col-12">
      <label>Status</label>
      <ng-select
        class="custom"
        [items]="statuses"
        name="status"
        [clearable]="false"
        [(ngModel)]="task.completionStatus"
      ></ng-select>
    </div>
  }
  @if (canChangeStatus && task.completionStatus != 'Completed') {
    <div class="col-12">
      <label>Customer's Issue</label>
      <textarea
        pInputTextarea
        fluid
        [(ngModel)]="task.customerIssue"
        [rows]="3"
        name="customerIssue"
        style="width: 100%;"
        required
        placeholder=""
      ></textarea>
    </div>
  }
  @if (canChangeStatus && (task.completionStatus == 'Go Back' || isIncompleteGoBack)) {
    <div class="col-12">
      <label>Hours (For Go Back)</label>
      @if (task) {
        <input pInputText
          fluid
          name="goBackHours"
          required
          [(ngModel)]="task.goBackHoursEstimate"
          />
      }
    </div>
  }
  @if (canChangeStatus && (task.completionStatus == 'Go Back' || isIncompleteGoBack)) {
    <div class="col-12">
      <label>Required Equipment (For Go Back)</label>
      @if (task) {
        <ng-select
          name="goBackEquipment"  
          class="multi-custom"
          [items]="goBackEquipmentOptions"
          [multiple]="true"
          [closeOnSelect]="false"
          [searchable]="true"
          [clearSearchOnAdd]="true" 
          placeholder="Choose"
          [(ngModel)]="task.wellnessTaskGoBackEquipment"
          [required]="true"
          [searchFn]="equipmentSearchFn"
        >
          <ng-template ng-label-tmp let-item="item">
            <div>
              <span>{{item.equipmentType.type}}</span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            <span>{{ item.equipmentType.type }}</span>
          </ng-template>
        </ng-select>
      }
    </div>
  }
  @if (canChangeStatus && (task.completionStatus == 'Go Back' || isIncompleteGoBack)) {
    <div class="col-12">
      <label>Uploads (For Go Back)</label>
      <app-blob-manager [angularUpload]="true"
        [containerName]="'wellness-task-go-back'"
        [parentRecordId]="uploadId"
        [uploadLabel]="'Document/Photo'"
        [viewOnly]="!canEditUploads">
      </app-blob-manager>
    </div>
  }
  <div class="col-12">
    <p-card>
      <div class="p-grid">
        <div class="col-6">
          <h6>Task Name</h6>
          @if (task) {
            <input pInputText
              name="name"
              fluid
              [(ngModel)]="task.name"
              [disabled]="!isEditable || limitEditing"
              required />
          }
        </div>
        <div class="col-6">
          <h6>Growing Degree Day</h6>
          @if (task) {
            <input pInputText
              fluid
              name="gdd"
              type="number"
              min="0"
              oninput="validity.valid||(value='');"
              [(ngModel)]="task.growingDegreeDay"
              [disabled]="!isEditable || limitEditing"
              />
          }
        </div>
        <div class="col-6">
          <h6>Price</h6>
          @if (task) {
            <app-no-decimal-input 
              [name]="'price'" 
              [isRequired]="true" 
              [isDisabled]="!isEditable || isInvoiced" 
              [value]="task.price"
              (emitResult)="task.price=$event"
          ></app-no-decimal-input>
          }
        </div>
        <div class="col-6">
          <h6>Hours Estimate</h6>
          @if (task) {
            <input pInputText
              fluid
              name="hours"
              required
              inputmode="decimal"
              [(ngModel)]="task.hours"
              [disabled]="!isEditable || limitEditing" />
          }
        </div>
        <div class="col-12 columnPadding topMargin">
          <h6>Description</h6>
          @if (task) {
            <textarea pInputTextarea
              fluid
              name="description"
              required
              class="form-control"
              [(ngModel)]="task.description"
              [rows]="8"
              style="width: 100%;"
              [disabled]="!isEditable">
            </textarea>
          }
        </div>
      </div>
    </p-card>
  </div>
  <div class="col-12 multiSelect">
    <h6>Tree Type(s)</h6>
    @if (task) {
      <ng-select
        name="treeTypes"  
        class="multi-custom"
        [items]="treeTypeOptions"
        [multiple]="true"
        [closeOnSelect]="false"
        [searchable]="true"
        [clearSearchOnAdd]="true" 
        placeholder="Choose"
        [(ngModel)]="task.wellnessTaskTreeTypes"
        [disabled]="!isEditable || limitEditing"
        [required]="true"
        [searchFn]="treeTypeSearchFn"
      >
        <ng-template ng-label-tmp let-item="item">
          <div>
              @if (item.treeType) {
                <span>{{item.treeType.commonName}}</span>
              }
              @if (!item.treeType) {
                <span>Unknown</span>
              }
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
          <span>{{ item.treeType?.label }}</span>
        </ng-template>
      </ng-select>
    }
  </div>
  <div class="col-12">
    <h6>Location of Tree(s)</h6>
    @if (task) {
      <textarea pInputTextarea
        [(ngModel)]="task.location"
        [disabled]="!isEditable || limitEditing"
        class="form-control"
        [rows]="2"
        name="location"
        style="width: 100%;"
        required
        >
      </textarea>
    }
  </div>
  <div class="col-12 multiSelect">
    <h6>Required Skill(s)/Certification(s)</h6>
    @if (task) {
      <ng-select
        name="skills"  
        class="multi-custom"
        [items]="skillOptions"
        [multiple]="true"
        [closeOnSelect]="false"
        [searchable]="true"
        [clearSearchOnAdd]="true" 
        placeholder="Choose"
        [(ngModel)]="task.wellnessTaskSkills"
        [disabled]="!isEditable || limitEditing"
        [searchFn]="skillSearchFn"
      >
        <ng-template ng-label-tmp let-item="item">
          <div>
            <span>{{item.skill.name}}</span>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
          <span>{{ item.skill.name }}</span>
        </ng-template>
      </ng-select>
    }
  </div>
  <div class="col-12 multiSelect">
    <h6>Required Equipment Type(s)</h6>
    @if (task) {
      <ng-select
        name="equipment"  
        class="multi-custom"
        [items]="equipmentOptions"
        [multiple]="true"
        [closeOnSelect]="false"
        [searchable]="true"
        [clearSearchOnAdd]="true" 
        placeholder="Choose"
        [(ngModel)]="task.wellnessTaskEquipment"
        [disabled]="!isEditable || limitEditing"
        [searchFn]="equipmentSearchFn"
      >
        <ng-template ng-label-tmp let-item="item">
          <div>
            <span>{{item.equipmentType.type}}</span>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
          <span>{{ item.equipmentType.type }}</span>
        </ng-template>
      </ng-select>
    }
  </div>
  <div class="col-12">
    <h6>Schedulable After The Completion Of</h6>
    @if (task) {
      <ng-select
        class="custom"
        [items]="dependencyOptions"
        [disabled]="!isEditable || limitEditing"
        [selectOnTab]="true"
        placeholder="Does this task require another task to be completed first?"
        name="SchedulableAfterCompletionOf"
        bindLabel="name"
        bindValue="id"
        (change)="onSchedulableAfterCompletionOfIdChange()"
        [(ngModel)]="task.schedulableAfterCompletionOfId"
        >
      </ng-select>
    }
  </div>
  @if (isQuoteTask) {
    <div class="col-12">
      <h6>Offer Yearly Auto Renew Service</h6>
      @if (task) {
        <p-radiobutton
          name="renewable"
          [value]="true"
          [(ngModel)]="task.renewable"
          [disabled]="!isEditable || limitEditing"
          required
          >
        </p-radiobutton>
        <label for="renewable">Yes</label>
      }&nbsp;&nbsp;
      @if (task) {
        <p-radiobutton
          name="notRenewable"
          [value]="false"
          [(ngModel)]="task.renewable"
          [disabled]="!isEditable || limitEditing"
          required
          >
        </p-radiobutton>
        <label for="notRenewable">No</label>
      }
    </div>
  }
  @if (task.renewable && !isQuoteTask) {
    <div class="col-12">
      <h6>Service Will Renew</h6>
      @if (task) {
        <p-radiobutton
          name="willRenew"
          [value]="true"
          [(ngModel)]="task.renewalAccepted"
          [disabled]="(!isEditable || isSaving || limitEditing) && !canChangeStatus && !task.renewed"
          required
          >
        </p-radiobutton>
        <label for="willRenew">Yes</label>
      }&nbsp;&nbsp;
      @if (task) {
        <p-radiobutton
          name="willNotRenew"
          [value]="false"
          [label]="'No'"
          [(ngModel)]="task.renewalAccepted"
          [disabled]="(!isEditable || isSaving || limitEditing) && !canChangeStatus && !task.renewed"
          required
          >
        </p-radiobutton>
        <label for="willNotRenew">No</label>
      }
    </div>
  }
  <div class="col-12">
    <h6>Priority</h6>
    @if (!refreshPriority) {
      <app-priority-and-date-selector
        #prioritySelector
        [(taskOrQuote)]="task"
        [isEditable]="isEditable && !limitEditing"
        [showRangeCalculationOption]="showRangeCalculationOption"
        [overrideWellness]="overrideWellness">
      </app-priority-and-date-selector>
    }
    <app-loading-swirly [isLoading]="refreshPriority"></app-loading-swirly>
  </div>
  <div class="col-12">
    <h6>Uploads:</h6>
    <app-blob-manager [angularUpload]="true"
      [containerName]="'wellness-task'"
      [parentRecordId]="uploadId"
      [uploadLabel]="'Document/Photo'"
      [viewOnly]="!canEditUploads || limitEditing">
    </app-blob-manager>
  </div>

  @if (!isQuoteTask && !task.id || task.customerSignature) {
    <span>
      <app-legal-acceptance-verbiage [paymentDueOption]="workOrder.paymentDueOption" [customerType]="workOrder.customer.customerTypeId"> </app-legal-acceptance-verbiage>
      <br/>
      <app-signature-area
        [signature]="task.customerSignature"
        [isAlwaysDisabled]="task.id"
        [name]="'Customer'"
        (currentSignature)="onUpdatedSignature($event)"
        >
      </app-signature-area>
    </span>
  }

  <div class="col-12 columnPadding">
    @if (wellnessTaskForm.invalid && wellnessTaskForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
    }
    @if (showSignError) {
      <div class="alert alert-danger" role="alert">
        Please have the customer sign above.
      </div>
    }
  </div>
  <div class="col-12">
    <div class="p-grid">
      <div class="col-12 columnPadding" style="text-align: right;">
        @if (isEditable && task.id && !limitEditing) {
          <p-button 
            type="button"
            severity="danger"
            (click)="deleteButtonPressed()"
            label="Delete"
            [disabled]="isInvoiced"
            >
          </p-button>
        }
        <p-button 
          type="button"
          severity="warn"
          (click)="cancelButtonPressed()"
          label="Cancel">
        </p-button>
        <p-button 
          type="submit"
          severity="success"
          (click)="saveTask(wellnessTaskForm)"
          [disabled]="(!isEditable || isSaving) && !canChangeStatus"
          label=" Save">
        </p-button>
      </div>
    </div>
  </div>
</form>